import { render, staticRenderFns } from "./Restricao.vue?vue&type=template&id=3e8cb1d8"
import script from "./Restricao.vue?vue&type=script&lang=js"
export * from "./Restricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports